let csrfTokenPromise = null;

export async function fetchCsrf(fetchData) {
  if (!csrfTokenPromise) {
    csrfTokenPromise = await fetchData('/actions/users/session-info').then((response) => {
      const { csrfTokenName, csrfTokenValue } = response;
      // Cache the CSRF token name and value for future use
      return { csrfTokenName, csrfTokenValue };
    });
  }

  return csrfTokenPromise;
}
